import React from 'react'
import Header from './Header'
import Footer from './Footer'

type LayoutProps = {
    children: React.ReactNode
}

const Layout = (props: LayoutProps) => {
    const { children } = props

    return (
        <>
            <Header onChangeMenu={() => {}} />
            <div className="wrapper wrapper-body wrapper__minify" style={{ transition: 'margin-left 0.3s ease-out', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="dashboard-body" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <div className="container-fluid" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ flex: 1 }}>
                            {children}
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Layout